<template>
	<div class="img" :class="[responsiveClasses, 'el-'+details.id, classes]" :style="wrapperStyle">
		<v-style>
			{{css}}
		</v-style>
		<a v-if="linkUrl&&linkUrl!=='#no-action'&&linkUrl!=='#'"
		   :id="advanced.cssId"
		   :href="linkUrl" :target="linkTarget">
			<img v-if="isImgx" crossorigin="anonymous"
			     :src="!lazyload?imgxSrc:'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=='"
			     :data-srcset="imgxSrcSet"
			     :alt="basic.alt"
			     data-sizes="auto"
			     :data-src="imgxSrc"
			     :class="['lazyload',advanced.cssClasses]"
			     :width="width"
			     :height="height" :style="style">
			<img v-else crossorigin="anonymous"
			     :src="!lazyload?$trimSrc(imgSrc):'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=='"
			     :data-src="$trimSrc(imgSrc)"
			     :alt="basic.alt"
			     :class="['lazyload',advanced.cssClasses]"
			     :width="width"
			     :height="height"
			     :style="style">
		</a>
		<img v-else-if="isImgx" crossorigin="anonymous"
		     :src="!lazyload?imgxSrc:'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=='"
		     :data-srcset="imgxSrcSet"
		     :alt="basic.alt"
		     data-sizes="auto"
		     :data-src="imgxSrc"
		     :class="['lazyload',advanced.cssClasses]"
		     :width="width"
		     :id="advanced.cssId"
		     :height="height" :style="style">
		<img v-else crossorigin="anonymous"
		     :src="!lazyload?$trimSrc(imgSrc):'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=='"
		     :data-src="$trimSrc(imgSrc)"
		     :alt="basic.alt"
		     :id="advanced.cssId"
		     :class="['lazyload',advanced.cssClasses]"
		     :width="width"
		     :height="height"
		     :style="style">

	</div>
</template>

<script>
import {borderProps, boxShadow, getPadding, responsiveAlignStyles} from "@/modules/page-editor/src/utils/props";
import {linkTarget, linkUrl} from "@/helpers/actionData";

export default {
	name: 'EmailImage',
	props: ['details'],
	computed: {
		imgSrc() {
			return this.basic.image ? this.basic.image : 'images.funnelish.com/default/default-image.svg';
		},
		basic() {
			return this.details.attributes.basic;
		},
		advanced() {
			return this.details.attributes.advanced
		},
		responsive() {
			return this.details.responsive
		},
		classes() {
			return this.basic.previewProductImage ? 'product-image-preview' : '';
		},
		responsiveClasses() {
			let c = '';
			if (!this.responsive) return '';
			if (!this.responsive.desktop) c = 'no-desktop';
			if (!this.responsive.mobile) c += ' no-mobile';
			if (!this.responsive.tablets) c += ' no-tablet';
			return c;
		},
		linkUrl() {
			return linkUrl(this.basic.clickAction);
		},
		linkTarget() {
			return linkTarget(this.basic.clickAction);
		},
		lazyload(){
			return !this.basic.lazyload || this.basic.lazyload.booleanValue===true;
		},
		height() {
			let currentHeight = this.basic.size && this.basic.size.height ? this.basic.size.height : 'auto';
			if(currentHeight !== 'auto') return currentHeight + 'px';
			else return currentHeight;
		},
		width() {
			let currentWidth = this.basic.size && this.basic.size.width ? this.basic.size.width : '100%';
			if(currentWidth !== '100%') {
				return currentWidth + 'px';
			} else {
				return '100%'
			}
		},
		imgxSizes() {
			if (!this.width) {
				return "100vw"
			} else {
				return this.width + "px"
			}
		},
		fh() {
			return this.height.indexOf("px")>=0 ? this.height.replace("px","") : "";
		},
		fw() {
			return this.width.indexOf("px")>=0 ? this.width.replace("px","") : "";
		},
		imgxSrc() {
			let src = this.imgSrc.replace("https://", "")
			if (src.indexOf("images.funnelish.com") >= 0) {
				src = src.replace("images.funnelish.com", "img.funnelish.com");
				return `//${src}?auto=webp&clip=bounds${this.fw?`&width=${this.fw}`:''}${this.fh?`&height=${this.fh}`:''}`;
			}
			return `//${src}`;
		},
		imgxSrcSet() {
			let src = this.imgxSrc;
			// prevent compressing gif/svg
			if (this.isGif(src)) return `${src}`;

			return `${src} 1x`; // , ${src}&dpr=2 2x
		},
		isImgx() {
			// prevent compressing gif/svg
			return (this.imgSrc.indexOf("img.funnelish.com") >= 0 || this.imgSrc.indexOf("images.funnelish.com") >= 0 || this.imgSrc.indexOf("fnsh.imgix.net") >= 0)
		},
		css() {
			return responsiveAlignStyles(this.basic.align, this.details.id);
		},
		style() {
			return {
				...borderProps(this.basic.border),
				boxShadow: boxShadow(this.basic.shadows),
				objectFit: this.basic.fitImage ? this.basic.fitImage : null,
			};
		},
		wrapperStyle() {
			return {
				margin: getPadding(this.basic.margin),
			};
		},
		clickAction() {
			return (this.basic.clickAction ? this.basic.clickAction.mainToggle : 'No action');
		}
	},
	methods:{
		isGif(src){
			let match = src.match(/\.[0-9a-z]+$/i)
			return (match && ['.svg','.gif'].includes(match[0]));
		}
	}
}
</script>
